<template>
  <div id="myDateShow">
    <div class="title">查看 订单资料</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">订单Id</div>
        <div class="value">{{orderInfo.orderId}}</div>
      </div>
      <div class="line">
        <div class="key">下单用户</div>
        <div class="value">{{orderInfo.userName}}</div>
      </div>
      <div class="line">
        <div class="key">下单时间</div>
        <div class="value">{{orderInfo.orderCreateTime}}</div>
      </div>
      <div class="line" v-if="orderInfo.payTime">
        <div class="key">支付时间</div>
        <div class="value">{{orderInfo.payTime}}</div>
      </div>
      <div class="line" v-if="orderInfo.overTime">
        <div class="key">完结时间</div>
        <div class="value">{{orderInfo.overTime}}</div>
      </div>
      <div class="line">
        <div class="key">商品名称</div>
        <div class="value">{{orderInfo.skuName}}</div>
      </div>
      <div class="line" v-if="orderInfo.pmsSkuInfo.specialClassify">
        <div class="key">商品特殊类型</div>
        <div class="value">{{orderInfo.pmsSkuInfo.specialClassify}}</div>
      </div>
      <div class="line">
        <div class="key">订单状态</div>
        <div class="value">{{orderInfo.state}}</div>
      </div>
      <div v-if="orderInfo.pmsSkuInfo.specialClassify=='坞栈商品'">
        <div class="line" v-if="orderInfo.orderPostage">
          <div class="key">配送类型</div>
          <div class="value">{{orderInfo.orderPostage}}</div>
        </div>
        <div class="line" v-if="orderInfo.orderPostageState">
          <div class="key">配送状态</div>
          <div class="value">
            <div>{{orderInfo.orderPostageState}}</div>
            <el-button type="primary" size="small" @click="peisong">已配送</el-button>
            <el-button type="primary" size="small" @click="ziti">已自提</el-button>
          </div>
        </div>
<!--        <div class="line" v-if="orderInfo.coveShed">-->
<!--          <div class="key">心坞栈覆盖的区域</div>-->
<!--          <div class="value">-->
<!--            <div class="tag" v-for="(item,index) in orderInfo.coveShed.coveShedAddresses">-->
<!--              <span>{{item.labelTwoName}}</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="line" v-if="orderInfo.coveShed">
          <div class="key">心坞栈名称</div>
          <div class="value">{{orderInfo.coveShed.coveShedName}}</div>
        </div>
        <div class="line" v-if="orderInfo.coveShed">
          <div class="key">心坞栈地址</div>
          <div class="value">{{orderInfo.coveShed.coveShedAddress}}</div>
        </div>
        <div class="line" v-if="orderInfo.coveShed">
          <div class="key">心坞栈类型</div>
          <div class="value">{{orderInfo.coveShed.coveShedClassify}}</div>
        </div>
        <div class="line" v-if="orderInfo.coveShed">
          <div class="key">联系人</div>
          <div class="value">{{orderInfo.coveShed.coveShedUsername}}</div>
        </div>
        <div class="line" v-if="orderInfo.coveShed">
          <div class="key">联系人手机号</div>
          <div class="value">{{orderInfo.coveShed.coveShedPhone}}</div>
        </div>
      </div>

      <div class="line" v-if="orderInfo.state=='退款中'">
        <div class="key">是否同意退款</div>
        <div class="value">
          <el-button type="warning" size="small" @click="refundOrderBut">同意退款</el-button>
          <el-button type="danger" size="small" @click="unRefundOrderBut">拒绝退款</el-button>
        </div>
      </div>
      <div class="line" v-if="orderInfo.refundWhy">
        <div class="key">取消/退款原因</div>
        <div class="value">{{orderInfo.refundWhy}}</div>
      </div>
      <div class="line">
        <div class="key">是否分享</div>
        <div class="value">{{orderInfo.isShare=='1'?'分享':'未分享'}}</div>
      </div>
      <div class="line">
        <div class="key">购买数量</div>
        <div class="value">{{orderInfo.skuNumber}}</div>
      </div>
      <div class="line">
        <div class="key">商品单价</div>
        <div class="value">{{orderInfo.skuPrice}}</div>
      </div>
      <div class="line">
        <div class="key">商品总价</div>
        <div class="value">{{orderInfo.skuSumPrice}}</div>
      </div>
      <div class="line" v-if="orderInfo.payGold">
        <div class="key">支付价格</div>
        <div class="value">{{orderInfo.payGold}}</div>
      </div>
      <div class="line" v-if="orderInfo.payWay!=0">
        <div class="key">支付方式</div>
        <div class="value">{{orderInfo.payWay=='1'?'微信支付':'其他支付'}}</div>
      </div>
      <div class="line" v-if="orderInfo.payNum">
        <div class="key">支付交易号</div>
        <div class="value">{{orderInfo.payNum}}</div>
      </div>
      <div class="line" v-if="orderInfo.isCoupons">
        <div class="key">优惠券</div>
        <div class="value">{{orderInfo.isCoupons=='0'?'未使用':'已使用'}}</div>
      </div>
      <div v-for="item in orderInfo.userCouponsList" v-if="orderInfo.isCoupons=='1'">
        <div class="line">
          <div class="key">优惠券名称</div>
          <div class="value">{{item.coupons.couponsName}}</div>
        </div>
        <div class="line">
          <div class="key">优惠金额</div>
          <div class="value">{{item.coupons.faceValue}}</div>
        </div>
      </div>
      <div class="line" v-if="orderInfo.isInvoice">
        <div class="key">发票状态</div>
        <div class="value">{{orderInfo.isInvoice=='0'?'未开具':'已开具普通发票'}}</div>
      </div>
      <div class="line">
        <div class="key">收货人</div>
        <div class="value">{{orderInfo.userReceiveAddress.name}}</div>
      </div>
      <div class="line">
        <div class="key">收货手机号</div>
        <div class="value">{{orderInfo.userReceiveAddress.telNumber}}</div>
      </div>
      <div class="line">
        <div class="key">收货地址</div>
        <div class="value">{{orderInfo.userReceiveAddress.provinceName}}{{orderInfo.userReceiveAddress.cityName}}{{orderInfo.userReceiveAddress.countyName}}{{orderInfo.userReceiveAddress.detailInfo}}</div>
      </div>
      <div v-if="orderInfo.pmsSkuInfo.specialClassify!='坞栈商品'">
        <div class="line" v-if="orderInfo.state=='已支付'">
          <div class="key">物流信息</div>
          <div class="value">
            <el-select v-if="isLogisticsCode" style="width: 150px;" v-model="selectLogistics" placeholder="选择物流公司">
              <el-option  v-for="item in logisticsCompany"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
              </el-option>
            </el-select>
            <el-button v-if="!isLogisticsCode" type="primary" size="medium" @click="logistics">填写快递单号</el-button>
            <el-input  v-if="isLogisticsCode" style="width: 300px" v-model="orderInfo.logistics.logisticCode" placeholder="请填写发货快递单号"></el-input>
            <el-button v-if="isLogisticsCode" type="primary" style="margin-left: 20px" size="medium" @click="submitLogistics">提交</el-button>
          </div>
        </div>
        <div class="line" v-if="orderInfo.state=='已发货'">
          <div class="key">快递公司</div>
          <div class="value">{{orderInfo.logistics.shipperCode}}</div>
        </div>
        <div class="line" v-if="orderInfo.state=='已发货'">
          <div class="key">快递单号</div>
          <div class="value">
            {{orderInfo.logistics.logisticCode}}
            <el-button v-if="!isUpdateLogisticsCode" type="primary" style="margin-left: 20px" size="medium" @click="logisticsUpdate">更换快递单号</el-button>
            <el-select v-if="isUpdateLogisticsCode" style="width: 150px;" v-model="selectLogistics" placeholder="选择物流公司">
              <el-option  v-for="item in logisticsCompany"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
              </el-option>
            </el-select>
            <el-input v-if="isUpdateLogisticsCode" style="width: 200px" v-model="orderInfo.logistics.logisticCode" placeholder="请填写发货快递单号"></el-input>
            <el-button v-if="isUpdateLogisticsCode" type="primary" style="margin-left: 20px" size="medium" @click="submitLogistics">提交</el-button>
          </div>
        </div>
        <div class="line">
          <div class="key">物流状态</div>
          <div class="value">{{orderInfo.logistics.logisticsState}}</div>
        </div>
        <div class="line">
          <div class="key">快递轨迹</div>
          <div class="value" style="white-space: pre-line;">
            {{orderInfo.logistics.traces}}
          </div>
        </div>
      </div>

      <div class="line" v-if="orderInfo.state!='已失效'">
        <div class="key">检查订单是否完成支付/退款</div>
        <div class="value">
          <el-button type="primary" size="small" @click="checkOrder">检查订单</el-button>
        </div>
      </div>
      <div class="line" v-if="orderInfo.state!='已失效'">
        <div class="key">订单作废</div>
        <div class="value">
          <el-button type="danger" size="small" @click="invalidOrder">异常作废</el-button>
        </div>
      </div>
    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {checkOrderState, getOrderById, newVue, invalidOrder, refundOrder, unRefundOrder,logisticsCode,unOrderState} from "../../network/order";
  import {utilVue, successMsg, errorMsg} from "../../utils/util";

  export default {
    name: "orderData",
    components: {},
    data(){
      return{
        orderId:"",
        orderInfo:{
          logistics:{},
          pmsSkuInfo:{
            pmsSkuClassify:{}
          },
          userReceiveAddress:{}
        },
        isLogisticsCode:false,
        isUpdateLogisticsCode:false,
        selectLogistics:"",
        logisticsCompany: [
          {
            value:"yuantongguoji",
            label:"圆通"
          },
          {
            value:"shentong",
            label:"申通"
          },
          {
            value:"huitongkuaidi",
            label:"百世"
          }
        ],
      }
    },
    methods:{
      peisong(){
        unOrderState(this.orderId,3).then(e => {
          getOrderById(this.orderId).then(res => {
            let order = this.processorData(res.data)
            if (order.orderClassify=="合并总订单"){
              order.pmsSkuInfo = {}
            }
            this.orderInfo = order
          })
        })
      },
      ziti(){
        unOrderState(this.orderId,4).then(e => {
          getOrderById(this.orderId).then(res => {
            let order = this.processorData(res.data)
            if (order.orderClassify=="合并总订单"){
              order.pmsSkuInfo = {}
            }
            this.orderInfo = order
          })
        })
      },
      submitLogistics(){
        if (this.selectLogistics==""){
          this.$confirm('请选择物流公司', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          return;
        }
        logisticsCode(this.orderInfo.orderId,this.orderInfo.logistics.logisticCode,this.selectLogistics).then(res => {
          this.getOrder();
          this.isUpdateLogisticsCode=false
        })
      },
      logistics(){
        this.isLogisticsCode = true
      },
      logisticsUpdate(){
        this.isUpdateLogisticsCode = true
      },

      backClick(){
        this.$router.back();
      },
      checkOrder(){
        checkOrderState(this.orderId).then(res => {
          this.orderInfo = this.processorData(res.data)
          successMsg(res.date.noteMessage);
        })
      },
      refundOrderBut(){
        this.$confirm('您已同意退款申请, 是否确定?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          refundOrder(this.orderId).then(res => {
            getOrderById(this.orderId).then(res => {
              this.orderInfo = this.processorData(res.data)
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      unRefundOrderBut(){
        this.$confirm('您已拒绝退款申请, 是否确定?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          unRefundOrder(this.orderId).then(res => {
            getOrderById(this.orderId).then(res => {
              this.orderInfo = this.processorData(res.data)
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      invalidOrder(){
        this.$confirm('此操作将作废该订单，将不可继续支付/退款, 是否确定作废?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          invalidOrder(this.orderId)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });

      },
      processorData(data){
          let state = data.state
          if (state == "0"){
            data.state = "未支付"
          }else if (state == "1"){
            data.state = "已支付"
            data.orderPostageState = "未自提/未配送"
          }else if (state == "2"){
            data.state = "已失效"
          }else if (state == "3"){
            data.state = "已发货"
            data.orderPostageState = "配送中"
          }else if (state == "4"){
            data.state = "已签收"
            data.orderPostageState = "已自提"
          }else if (state == "5"){
            data.state = "退款中"
          }else if (state == "6"){
            data.state = "已退款"
          }
          let shipperCode = data.logistics.shipperCode;
          if (shipperCode=="HTKY"){
            shipperCode = "百世快递"
          }else if (shipperCode=="HHTT"){
            shipperCode = "天天快递"
          }else if (shipperCode=="STO"){
            shipperCode = "申通快递"
          }else if (shipperCode=="YTO") {
            shipperCode = "圆通快递"
          }
        data.logistics.shipperCode = shipperCode
        return data;
      },
      getOrder(){
        getOrderById(this.orderId).then(res => {
          this.orderInfo = this.processorData(res.data)
        })
      }
  },
    created() {
      newVue.obj = this;
      utilVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/order/list";
      this.common.HeaderLocationTwo.name =  "订单管理"
      this.common.HeaderLocationThree.name = "订单详情"
      if (this.$route.params.id != null) {
        this.orderId = this.$route.params.id;

        getOrderById(this.orderId).then(res => {
          let order = this.processorData(res.data)
          if (order.orderClassify=="合并总订单"){
            order.pmsSkuInfo = {}
          }
          this.orderInfo = order
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";

  .tag {
    display: inline-block;
    height: 30px;
    background-color: #67c23a;
    border-color: #e9e9eb;
    color: white;
    box-sizing: border-box;
    margin: 2px 6px 2px 0;
    padding: 0 8px;
    line-height: 30px;
  }

  .skuImg{
    width: 148px;
    height: 117px;
    display: inline-block;
    vertical-align: top;
    margin-right: 30px;
  }
  .skuImg img{
    width: 148px;
    height: 117px;
  }

  .tag span {
    margin-right: 3px;
  }
</style>
